import axios from 'axios'
import exceptionHandler from '@/common/exception-handler'
import _ from 'lodash'
import employmentDefaults from './employment-defaults'

const setLastUserEmploymentLocation = (email, locationId) => {
  localStorage[`user_employment_location::${email}`] = locationId
}

const getLastUserEmploymentLocation = email => {
  return localStorage[`user_employment_location::${email}`]
}

const getCompanyEmployment = (companyId, expectedVersion, expectedId) => {
  return getEmployment(`/api/blobs/employment/company/${companyId}`, expectedVersion, expectedId)
}

const getTemplateEmployment = () => {
  return getEmployment('/api/blobs/employment/template')
}

const saveLocationEmployment = (locationId, overrides, loadedLocationId, attempt) => {
  // TPOS-10162: loadedLocationId is the locationId the caller loaded employment for, captured
  // independently at load time — sent as a query param so the back-end can reject the save if
  // it disagrees with the URL's locationId (defense in depth against a stale/cached session).
  // This endpoint is shared with location-settings-service.js's saveLocationSettings.
  return axios.put(`/api/blobs/employment/overrides/location/${locationId}`, overrides, { params: { loadedLocationId } })
    .catch(error => exceptionHandler.parseWithRetryWhenConflict(error, attempt,
      next => saveLocationEmployment(locationId, overrides, loadedLocationId, next)))
}

const saveCompanyEmployment = (companyId, employmentBlob) => {
  return axios.put(`/api/blobs/employment/company/${companyId}`, employmentBlob)
    .catch(error => exceptionHandler.parse(error))
}

export default {
  setLastUserEmploymentLocation,
  getLastUserEmploymentLocation,
  getCompanyEmployment,
  getTemplateEmployment,
  getLocationEmployment (locationId, expected) {
    return axios.get(`/api/blobs/employment/location/${locationId}`, { params: expected })
      .then(res => {
        let data = res.data

        if (!data.locationBlob && !data.override) {
          return 304
        }

        let diff = null
        let groupDiff = null

        if (!data.override) {
          if (!expected.expectedOverrideVer) {
            diff = { changes: [] }
          }
        } else {
          diff = JSON.parse(data.override)
        }

        if (data.groupOverride) {
          groupDiff = JSON.parse(data.groupOverride)
        }

        delete data.override
        delete data.groupOverride

        if (data.locationBlob) {
          data.employmentBlob = JSON.parse(data.locationBlob)
        }

        return { base: data, diff, groupDiff }
      })
      .catch(error => exceptionHandler.parse(error))
  },
  saveLocationEmployment,
  saveCompanyEmployment,
  getPublishedEmploymentBlob (locationId) {
    return axios.get('/api/published-config/employment/' + locationId)
      .then(result => result.data)
  },
  retrieveInvalidEmployees (companyId) {
    return axios.get(`/api/users/listInvalidUsers/${companyId}`)
      .then(result => result.data)
  },
  purgeEmployees (purgeBeforeEpoch, companyId) {
    return axios.post('/api/users/purge', { purgeBeforeEpoch, companyId })
      .then(res => res.data)
      .catch(error => exceptionHandler.parse(error))
  }
}

function getEmployment (url, expectedVersion, expectedId) {
  return axios.get(url, { params: { ...(expectedVersion ? { expectedVersion, expectedId } : {}) } })
    .then(res => {
      let employment = res.data

      if (employment.locationBlob) {
        employment.employmentBlob = JSON.parse(employment.locationBlob)
      } else {
        employment.employmentBlob = employmentDefaults()
        employment.$default = true
      }

      return employment
    })
    .catch(error => {
      if (_.get(error, 'response.status') === 304) {
        return 304
      }

      return exceptionHandler.parse(error)
    })
}
